module.exports = __webpack_public_path__ + "img/Loading_r_49.c0122cc1.png";